export const getCanvasSize = (state) => state.getIn(['app', 'canvas', 'size']);
